module.exports = __webpack_public_path__ + "static/media/arrow-left.34becb96.svg";